export const md = 1200;

export const sm = 768;

export const xs = 400;
